<template>
  <div class="multi-element" :class="{'has-ref': element.ref && element.ref.length > 0}">
    <ref :id="element.ref"/>
    <template v-for="child in element.elements">
      <character v-if="child.class === 'Character'" :character="child"/>
      <fragmented-verse v-else-if="child.class === 'FragmentedVerse'" :fragmented-verse="child"/>
      <multi-line v-else-if="child.class === 'StanzaStageDirection'" :element="child"/>
      <multi-line v-else-if="child.class === 'Prose'" :element="child"/>
      <multi-element v-else-if="child.class === 'MultilineRef'" :element="child"/>
    </template>
  </div>
</template>
<script>
  import Character from './Character'
  import FragmentedVerse from './FragmentedVerse'
  import MultiLine from './MultiLine'
  import Ref from './Ref'

  export default {
    name: 'MultiElement',
    components: {Ref, MultiLine, FragmentedVerse, Character},
    props: {
      element: {type: Object, required: true}
    }
  }
</script>
<style lang="scss">
  @import "app/javascript/scss/variables";

  .multi-element.has-ref {
    position: relative;
    border-top: 1px dashed $ref-border-color;
    border-bottom: 1px dashed $ref-border-color;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      border-left: 1px dashed $ref-border-color;
    }

    > .ref {
      position: absolute;
      z-index: 1;
      top: -10px;
      left: -8px
    }
  }
</style>